import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-126" data-mp="bq9f2pruf808">
      {visible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 md:bottom-4 md:left-1/2 md:right-auto md:w-[480px] md:-translate-x-1/2 md:px-0" data-id="element-127" data-mp="195wsldarnr9y">
          <a href={CHECKOUT_URL} onClick={() => window.fbq?.("track", "InitiateCheckout")} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-go px-4 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-6px_rgba(30,158,85,0.65)] focus:outline-none focus-visible:ring-4 focus-visible:ring-go/40" data-id="element-128" data-mp="2f653isc4zupx">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden data-id="element-129" data-mp="1idrqxzjbw9nn" />
            Get it now for $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}